import axios from "axios";
import { HStack } from "native-base";
import React, { useReducer, useState } from "react";
import { Platform, ScrollView, StyleSheet, View } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import { ArButton } from "../argon-ui";
import Theme from "../argon-ui/Theme";
import { IS_MOBILE, translate } from "../locales/translate";
import ModalBase from "../nativeBase-ui/ModalBase";
import { getDir, persianToEnglishNumber } from "../util";
import RegisterBuildingInput from "./RegisterBuildingInput";
import Text from "./TextFont";
import * as AppActions from "../actions/AppActions";
import * as SecureStore from "../components_v2/DeviceAsyncStorage";
import { DEFAULT_PORTS_BRAND, USER_ID } from "../../assets/consts";
import InputBase from "../nativeBase-ui/InputBase";
import BuildingInfo from "../viewModels/BuildingInfo";
import ServerInfo from "../viewModels/ServerInfo";
import DividerWithText from "./DividerWithText";
import QRScanner from "./QRScanner";
import ScannerCamera from "./ScannerCamera";
type Props = {
  showJoinModal: boolean;
  hideModal: () => void;
  changeBuilding: (buildingInfo: BuildingInfo, serverInfo: ServerInfo) => void;
};
interface BuildingList {
  buildingId: string;
  buildingName: string;
}
type FormValidityState = {
  codeLetterError: boolean;
  codeLetterErrorMessage: string;
  codeDigiError: boolean;
  codeDigiErrorMessage: string;
  isFormValid: boolean;
};
const initialValidityState: FormValidityState = {
  codeLetterError: false,
  codeLetterErrorMessage: "",
  codeDigiError: false,
  codeDigiErrorMessage: "",
  isFormValid: false,
};
type FormValidityAction = {
  type: string;
  payLoad: string;
};
const formValidityReducer = (
  state: FormValidityState,
  action: FormValidityAction
): FormValidityState => {
  let isValid: boolean = false;
  let IsRequired: string = "";
  switch (action.type) {
    case "VALIDATE_CODE_LETTER":
      isValid = action.payLoad.length == 3 ? true : false;
      IsRequired =
        action.payLoad.length == 0
          ? translate("building.registerBuildingFormError.requiredCodeLetter")
          : !isValid
          ? translate("building.registerBuildingFormError.lengthCodeLetter")
          : "";
      return {
        ...state,
        ...{
          codeLetterError: !isValid,
          isFormValid: (isValid || IsRequired == "") && !state.codeDigiError,
          codeLetterErrorMessage: IsRequired,
        },
      };
    case "VALIDATE_CODE_DIGI":
      isValid = action.payLoad.length == 4 ? true : false;
      IsRequired =
        action.payLoad.length == 0
          ? translate("building.registerBuildingFormError.requiredCodeDigi")
          : !isValid
          ? translate("building.registerBuildingFormError.lengthCodeDigi")
          : "";
      return {
        ...state,
        ...{
          codeDigiError: !isValid,
          isFormValid: (isValid || IsRequired == "") && !state.codeLetterError,
          codeDigiErrorMessage: IsRequired,
        },
      };
    case "IS_VALID":
      return {
        ...state,
        ...{
          isFormValid: true,
        },
      };
    default:
      return state;
  }
};

const ModalJoinBuilding = (props: Props) => {
  const { showJoinModal, changeBuilding, hideModal } = props;
  const [loading, setLoading] = useState<boolean>(false);
  const [showScanner, setShowScanner] = useState<boolean>(false);

  // === code Register state ===
  const [codeLetter, steCodeLetter] = useState<string>("");
  const [codeDigi, setCodeDigi] = useState<string>("");
  const [codeCompleted, setCodeCompleted] = useState<string>("");

  // === select building ===
  const [selectBuildingMode, setSelectBuildingMode] = useState<boolean>(false);
  const [selectCustomNameMode, setSelectCustomNameMode] =
    useState<boolean>(false);

  const [fetchBuildingList, setFetchBuildingList] = useState<
    BuildingList[] | []
  >([]);
  const [buildingId, setBuildingId] = useState<string>("");
  const [customBuildingName, setCustomBuildingName] = useState<string>("");
  const [customBuildingNamePlaceholder, setCustomBuildingNamePlaceholder] =
    useState<string>("");

  // === Redux
  const appReducer = useSelector((state: any) => state.AppReducer);
  const dispatch = useDispatch();
  // === fetch handler ===
  const postRegisterBuilding = async (
    code: string,
    bodySelectBuilding?: {
      buildingId?: string;
      customBuildingName?: string | null;
    }
  ) => {
    const { currentServer, serverUrl } = appReducer;
    const accessToken = currentServer.accessToken;
    var _serverUrl: string = serverUrl;
    const userId = await SecureStore.getItemAsync(USER_ID);
    if (!_serverUrl.endsWith("/")) {
      _serverUrl += "/";
    }
    if (_serverUrl && userId && accessToken) {
      interface BodyType {
        code: string;
        userId: string | null;
        [key: string]: any;
      }
      var body: BodyType = {
        code,
        userId,
      };

      if (!selectBuildingMode) {
        // === fetch register code ===
        const headersJson = {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        };
        axios
          .post(`${_serverUrl}Buildings/Join`, body, {
            headers: headersJson,
          })
          .then((res) => {
            if (res && !selectBuildingMode) {
              setFetchBuildingList(res.data);
              setSelectBuildingMode(true);
            }
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
            console.log("search register code error", error);
            const errorMessage = {
              title: translate(`login.errors.undefinedError`),
              variant: "top-accent",
              status: "error",
            };
            dispatch(AppActions.messageToast(errorMessage));
          });
      }
    }
    // === fetch selected building ===
    if (bodySelectBuilding) {
      body = {
        code,
        userId,
        buildingId: bodySelectBuilding?.buildingId,
        customBuildingName: bodySelectBuilding?.customBuildingName || null,
      };
      const headersJson = {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      };
      axios
        .post(`${_serverUrl}Buildings/Join`, body, {
          headers: headersJson,
        })
        .then((res) => {
          setLoading(false);
          if (res) {
            const {
              buildingId,
              serverId,
              localAddress,
              buildingName,
              modules,
            } = res.data?.buildingInfo;
            const {
              serverId: localServerId,
              publicAddress,
              accessToken,
              userFullName,
              userId,
              ports,
            } = res.data?.localServerInfo;
            const buildingInfoModel = BuildingInfo.parse({
              buildingId,
              serverId,
              localAddress,
              buildingName,
              modules,
              code,
            });
            const localServerInfoModel = ServerInfo.parse({
              serverId: localServerId,
              localAddress,
              publicAddress,
              accessToken,
              userFullName,
              userId,
              ports: ports || DEFAULT_PORTS_BRAND,
            });
            if (buildingInfoModel) {
              dispatch(AppActions.addBuilding(buildingInfoModel));
              Platform.OS !== "web" &&
                dispatch(AppActions.addServer(localServerInfoModel));
              hideModal();
              changeBuilding(buildingInfoModel, localServerInfoModel);
            }
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log("select building error", error);
          const errorMessage = {
            title: translate(`login.errors.undefinedError`),
            variant: "top-accent",
            status: "error",
          };
          dispatch(AppActions.messageToast(errorMessage));
        });
    }
    setTimeout(() => {
      setLoading(false);
    }, 7000);
  };
  // === validation ===
  const [formValidityData, setFormValidityData] = useReducer(
    formValidityReducer,
    initialValidityState
  );
  const submitHandler = () => {
    setFormValidityData({
      type: "VALIDATE_CODE_DIGI",
      payLoad: codeDigi,
    });
    setFormValidityData({
      type: "VALIDATE_CODE_LETTER",
      payLoad: codeLetter,
    });
    if (formValidityData.isFormValid) {
      setLoading(true);
      // === Sum of codes (prefix + letter + digi) ===
      var code: string = codeLetter.toLocaleUpperCase() + codeDigi;
      code = code.replace(/\s+/g, "");
      // === convert persian number to english number ===
      code = persianToEnglishNumber(code);
      setCodeCompleted(code);
      // === select building mode ===
      if (selectBuildingMode) {
        const bodySecondReq = {
          buildingId,
          customBuildingName: customBuildingName || null,
        };
        postRegisterBuilding(codeCompleted, bodySecondReq);
      } else {
        postRegisterBuilding(code);
      }
    }
  };
  const handleBarCodeScanned = ({ type, data }: any) => {
    // console.log("data on barCode scanned", data);
    try {
      setShowScanner(false);
      if (data) {
        setCodeCompleted(data);
        setLoading(true);
        setFormValidityData({
          type: "IS_VALID",
          payLoad: "",
        });
        postRegisterBuilding(data);
      }
      // this.onConfirmServer(data);
    } catch (err) {
      console.log("has error in get serverIp from Scan QRcode");
    }
  };
  const handleCancelScanning = () => {
    setShowScanner(false);
  };
  const onSelectBuilding = (buildingId: string, buildingName: string) => {
    setSelectCustomNameMode(true);
    setBuildingId(buildingId);
    setCustomBuildingNamePlaceholder(buildingName);
  };
  return (
    <ModalBase
      header={translate("building.joinBuilding")}
      isOpen={showJoinModal}
      onClose={() => props.hideModal()}
      footer={
        !selectBuildingMode &&
        !showScanner && (
          <HStack space={2} style={{ padding: 10 }}>
            <ArButton
              color="primary"
              onPress={() => submitHandler()}
              style={{ flex: 1, marginBottom: 0 }}
              isLoading={loading}
            >
              {translate("building.search")}
            </ArButton>
            <ArButton
              color="muted"
              variant="outline"
              onPress={() => props.hideModal()}
              style={{ flex: 1, marginBottom: 0 }}
            >
              {translate("app.cancel")}
            </ArButton>
          </HStack>
        )
      }
    >
      {selectBuildingMode ? (
        // === Custom Building Name ===
        selectCustomNameMode ? (
          <RenderCustomBuildingName
            loading={loading}
            customBuildingNamePlaceholder={customBuildingNamePlaceholder}
            onChangeText={(txt: string) => {
              setCustomBuildingName(txt);
            }}
            submitHandler={() => submitHandler()}
          />
        ) : fetchBuildingList.length === 1 ? (
          onSelectBuilding(
            fetchBuildingList[0].buildingId,
            fetchBuildingList[0].buildingName
          )
        ) : (
          // === select Building from buildingList(fetched by register code) ===
          <RenderSelectBuildings
            buildings={fetchBuildingList}
            loading={loading}
            submitHandler={() => submitHandler()}
            selectedBuilding={(buildingId, buildingName) => {
              onSelectBuilding(buildingId, buildingName);
            }}
          />
        )
      ) : (
        // === register code form ===
        <View
          style={[
            { padding: 8, marginTop: 5, direction: "ltr" },
            showScanner && { minHeight: "50%" },
            !showScanner && { paddingBottom: 0 },
          ]}
        >
          <Text
            style={{
              fontSize: 14,
              color: Theme.COLORS.MUTED,
              marginBottom: 10,
            }}
          >
            {translate("building.registerCodeInfo")}
          </Text>
          {!showScanner && (
            <>
              <RegisterBuildingInput
                codeLetter={codeLetter}
                steCodeLetter={steCodeLetter}
                codeDigi={codeDigi}
                setCodeDigi={setCodeDigi}
                formValidityData={formValidityData}
                setFormValidityData={(action: FormValidityAction) =>
                  setFormValidityData(action)
                }
                callbackRegister={() => submitHandler()}
              />

              {IS_MOBILE && (
                <>
                  <DividerWithText
                    label={translate("building.orRegisterDescQRCode")}
                  />
                  <QRScanner
                    onScanning={(isScanning: boolean) => {
                      setShowScanner(isScanning);
                    }}
                  />
                </>
              )}
            </>
          )}

          {/* === QR code scanner === */}
          {showScanner && (
            <ScannerCamera
              onBarCodeScanned={handleBarCodeScanned}
              onCancelScanning={() => handleCancelScanning()}
            />
          )}
        </View>
      )}
      <View />
    </ModalBase>
  );
};
const styles = StyleSheet.create({
  scanContainer: { flex: 1, position: "relative", marginVertical: 10 },
  overlay: { position: "absolute", top: 0, left: 0, right: 0, bottom: 0 },
  cancelButton: {
    position: "relative",
    top: 5,
    alignSelf: "center",
    width: "100%",
    // flex:1
  },
});
export default ModalJoinBuilding;

interface PropsBuildingList {
  buildings: BuildingList[] | [];
  selectedBuilding: (buildingId: string, buildingName: string) => void;
  submitHandler: () => void;
  loading: boolean;
}
const RenderSelectBuildings = ({
  buildings,
  selectedBuilding,
}: PropsBuildingList): React.ReactElement => {
  return (
    <View
      style={{
        padding: 8,
        marginTop: 5,
        direction: getDir(),
        maxHeight: "80%",
      }}
    >
      <ScrollView>
        {(buildings || []).map((building: BuildingList, i: number) => {
          // const [isOpen, setIsOpen] = useState(false);
          return (
            <ArButton
              key={i}
              mb="1.5"
              // icon={faBuilding}
              onPress={() =>
                selectedBuilding(building.buildingId, building.buildingName)
              }
              style={{
                flex: 1,
              }}
            >
              {building.buildingName}
            </ArButton>
          );
        })}
      </ScrollView>
    </View>
  );
};
const RenderCustomBuildingName = (props: any) => {
  const {
    loading,
    submitHandler,
    onChangeText,
    customBuildingNamePlaceholder,
  } = props;
  return (
    <View style={{ padding: 8, marginTop: 5, direction: getDir() }}>
      <InputBase
        label={translate("building.labelCustomBuildingName")}
        placeholder={customBuildingNamePlaceholder}
        inputStyle={{ height: 35 }}
        onChangeText={(txt: string) => onChangeText(txt)}
      />
      <ArButton
        color="primary"
        onPress={() => submitHandler()}
        style={{ marginBottom: 0, marginTop: 10 }}
        isLoading={loading}
      >
        {translate("building.joinToBuilding")}
      </ArButton>
    </View>
  );
};
